// Logic THUẦN (không DOM) của màn hình chính Bot đã gộp Xem trực tiếp (người dùng chốt 05/10/2026): nhóm/thứ tự ô, chữ chip "đang chạy",
// đếm bước chờ duyệt, chữ tình trạng, nhãn nút đỏ nháy, chọn ô tự bật hình và nhớ lựa chọn tay trong phiên. Kiểm bằng tests/unit/man-hinh-bot.test.ts.
// Vòng 2 (06/10/2026, người dùng: "cho bật hết đi"): tự bật hình cho MỌI bot trực tuyến, KHÔNG còn giới hạn số ô; thứ tự nhóm chỉ để SẮP XẾP.
// Vòng 3 (06/10/2026): bỏ nút Xem / Tắt hình; màn nào đang có hình tự lên đầu, bot không hình xuống dưới — xếp ỔN ĐỊNH có độ trễ (SapXepOnDinh).
import { soSanhTenBot } from "./logic-bot-duyet";
import type { Bot, TongQuanBot } from "./types";

export type NhomO = "captcha" | "cho-duyet" | "dang-chay" | "ranh" | "ngoai-tuyen";
const THU_TU_NHOM: Record<NhomO, number> = { captcha: 1, "cho-duyet": 2, "dang-chay": 3, ranh: 4, "ngoai-tuyen": 5 };

/** Bỏ dấu + hạ chữ thường để lọc tên theo kiểu gõ không dấu cũng khớp ("dựng" ~ "dung"). */
export const khongDau = (t: string): string => t.normalize("NFD").replace(/[̀-ͯ]/g, "").replace(/đ/g, "d").replace(/Đ/g, "D").toLowerCase();

const dangDung = (s: string | undefined): boolean => s === "paused_approval" || s === "paused_otp";

/** Số bước đang chờ duyệt: lấy số lớn hơn giữa máy chủ đếm và trạng thái WS tức thời; giá trị lạ (âm, NaN, chữ) → 0. */
export function demChoDuyet(b: Pick<Bot, "current">, tq: TongQuanBot | undefined): number {
  const sv = typeof tq?.soChoDuyet === "number" && Number.isFinite(tq.soChoDuyet) && tq.soChoDuyet > 0 ? Math.floor(tq.soChoDuyet) : 0;
  return Math.max(sv, b.current?.status === "paused_approval" ? 1 : 0);
}

/** Bot thuộc nhóm nào: ngoại tuyến thắng mọi thứ; rồi bị tạm dừng (CAPTCHA…) → chờ duyệt → đang chạy → rảnh. */
export function nhomCuaBot(b: Bot, tq: TongQuanBot | undefined): NhomO {
  if (!b.online) return "ngoai-tuyen";
  if (tq?.tamDung) return "captcha";
  if (dangDung(b.current?.status) || demChoDuyet(b, tq) > 0) return "cho-duyet";
  if (b.current || tq?.chuoi) return "dang-chay";
  return "ranh";
}

/** Hạng hiển thị trên lưới (nhỏ = lên trên): 0 CẦN XỬ LÝ (CAPTCHA / cần người / chờ duyệt) · 1 đang có hình · 2 trực tuyến chưa có hình · 3 ngoại tuyến. */
export type HangMan = 0 | 1 | 2 | 3;
/** Một bot phải giữ hạng mới liên tục chừng này mili giây thì thẻ mới đổi chỗ (trừ khi vào hạng 0 — cần xử lý — thì lên ngay). */
export const DO_TRE_DOI_CHO_MS = 4000;

/** Hạng QUAN SÁT được lúc này của một bot (chưa qua độ trễ): ngoại tuyến → 3; cần xử lý → 0; có hình → 1; còn lại → 2. */
export function hangMan(b: Bot, tq: TongQuanBot | undefined, coHinh: boolean): HangMan {
  if (!b.online) return 3;
  const n = nhomCuaBot(b, tq);
  if (n === "captcha" || n === "cho-duyet") return 0;
  return coHinh ? 1 : 2;
}

/**
 * Xếp thẻ ỔN ĐỊNH (06/10/2026): hạng đã CHỐT của mỗi bot chỉ đổi khi hạng quan sát khác hạng đã chốt liên tục ≥ độ trễ (mặc định 4 giây) — hình chập chờn,
 * khung lỗi thoáng qua, bot rớt mạng một nhịp không làm thẻ nhảy. Ngoại lệ: bot vừa thành "cần xử lý" (CAPTCHA…) lên đầu NGAY (người dùng phải thấy).
 * Bot lần đầu thấy → chốt luôn hạng quan sát. Trong cùng hạng: theo tên tự nhiên (Máy 2 trước Máy 10). Không phụ thuộc bộ lọc — luôn đưa ĐỦ bot vào.
 */
export class SapXepOnDinh {
  private readonly chot = new Map<string, HangMan>();
  private readonly cho = new Map<string, { hang: HangMan; tu: number }>();
  constructor(private readonly doTreMs: number = DO_TRE_DOI_CHO_MS) {}

  /** Trả danh sách bot đã xếp. `quanSat` = hạng quan sát theo mã bot; `bay` = giờ hiện tại (ms). */
  sapXep(bots: Bot[], quanSat: Map<string, HangMan>, bay: number): Bot[] {
    const co = new Set(bots.map((b) => b.id));
    for (const id of [...this.chot.keys()]) if (!co.has(id)) { this.chot.delete(id); this.cho.delete(id); }
    for (const b of bots) {
      const moi = quanSat.get(b.id) ?? 2;
      const cu = this.chot.get(b.id);
      if (cu === undefined) { this.chot.set(b.id, moi); continue; }
      if (moi === cu) { this.cho.delete(b.id); continue; }
      if (moi === 0) { this.chot.set(b.id, 0); this.cho.delete(b.id); continue; }
      const c = this.cho.get(b.id);
      if (!c || c.hang !== moi) this.cho.set(b.id, { hang: moi, tu: bay });
      else if (bay - c.tu >= this.doTreMs) { this.chot.set(b.id, moi); this.cho.delete(b.id); }
    }
    return [...bots].sort((a, b) => (this.chot.get(a.id) ?? 2) - (this.chot.get(b.id) ?? 2) || soSanhTenBot(a.name, b.name));
  }
  /** Còn bot nào đang chờ qua độ trễ để đổi chỗ không (để trang hẹn giờ tính lại). */
  get conCho(): boolean { return this.cho.size > 0; }
  hangDaChot(id: string): HangMan | undefined { return this.chot.get(id); }
}

/** Đèn LED ở "cằm" màn hình: tắt (ngoại tuyến) · xanh lá (trực tuyến, rảnh) · xanh lơ thở (đang chạy) · cam (chờ duyệt / OTP) · đỏ nháy (CAPTCHA / cần người). */
export type Led = "tat" | "ranh" | "chay" | "cho" | "can";
export const TEN_LED: Record<Led, string> = { tat: "ngoại tuyến", ranh: "trực tuyến, đang rảnh", chay: "đang chạy", cho: "chờ bạn duyệt", can: "cần bạn xử lý (CAPTCHA / xác minh)" };
export function ledCuaBot(online: boolean, nhom: NhomO): Led {
  if (!online || nhom === "ngoai-tuyen") return "tat";
  return nhom === "captcha" ? "can" : nhom === "cho-duyet" ? "cho" : nhom === "dang-chay" ? "chay" : "ranh";
}

export interface TenChip { kichBan?: string | null; buoc?: string | null }
/** Chữ nút "đang chạy" của thẻ: chuỗi → "Chuỗi T6H · bước 2/3"; kịch bản lẻ → "Kịch bản <tên> · <bước>"; không có gì → "Rảnh" (đang tạm dừng mạng → "Tạm dừng"). */
export function chuChip(b: Bot, tq: TongQuanBot | undefined, ten: TenChip): { text: string; loai: "chuoi" | "kich-ban" | "ranh" | "tam-dung" } {
  const c = tq?.chuoi;
  if (c) {
    const tong = Number.isFinite(c.tongBuoc) && c.tongBuoc > 0 ? Math.floor(c.tongBuoc) : 0;
    const n = Math.max(1, Math.floor(Number.isFinite(c.buocHienTai) ? c.buocHienTai : 0) + 1);
    const buoc = tong ? `${Math.min(n, tong)}/${tong}` : String(n);
    const them = c.trangThai === "nghi" ? " (đang nghỉ)" : c.trangThai === "cho_bot" ? " (chờ bot)" : "";
    return { text: `Chuỗi ${c.ten} · bước ${buoc}${them}`, loai: "chuoi" };
  }
  if (b.current) {
    const laKbSoDo = /^kb-[a-z0-9]{4,40}$/.test(b.current.bundleName);
    const tenKb = ten.kichBan ?? (laKbSoDo ? null : b.current.bundleName);
    return { text: ["Kịch bản" + (tenKb ? ` ${tenKb}` : " đang chạy"), ten.buoc || null].filter(Boolean).join(" · "), loai: "kich-ban" };
  }
  if (cacTamDung(tq).length) return { text: "Tạm dừng", loai: "tam-dung" }; // bot đang bị tạm dừng mạng mà chip ghi "Rảnh" là nói dối (B5, 09/10)
  return { text: "Rảnh", loai: "ranh" };
}

export type LoaiTinhTrang = "chay" | "cho-duyet" | "tam-dung" | "nghi" | "da-dung" | "loi" | "ranh" | "ngoai-tuyen";
const CHU_TAM_DUNG: Record<string, string> = {
  captcha: "cần giải CAPTCHA", checkpoint: "tài khoản cần xác nhận", xac_minh: "cần xác minh",
  dang_xuat: "tài khoản bị đăng xuất", spam: "bị cảnh báo spam",
  can_nguoi: "cần bạn xử lý",
};
const TEN_MANG_NGAN: Record<string, string> = { facebook: "Facebook", youtube: "YouTube", tiktok: "TikTok", x: "X", reddit: "Reddit", instagram: "Instagram", threads: "Threads" };
/** Tên mạng ngắn để ghép vào câu ("Tạm dừng TikTok: …"): 5 mạng đã biết viết đúng hoa/thường; mạng lạ → viết hoa chữ đầu; rỗng → "". */
export function tenMangNgan(ma: string | null | undefined): string {
  const m = (ma ?? "").trim();
  if (!m) return "";
  return TEN_MANG_NGAN[m.toLowerCase()] ?? `${m.charAt(0).toUpperCase()}${m.slice(1)}`;
}
/** “Tạm dừng TikTok: cần giải CAPTCHA” — nêu MẠNG (bot có thể tạm dừng nhiều mạng cùng lúc); không biết mạng thì “Tạm dừng: …”. */
export function chuTamDung(td: { mang?: string | null; ma: string }): string {
  const mang = tenMangNgan(td.mang);
  return `Tạm dừng${mang ? ` ${mang}` : ""}: ${CHU_TAM_DUNG[td.ma] ?? "cần xử lý trên máy bot"}`;
}
/** Mọi lần tạm dừng chưa xử lý của bot, mới nhất trước, bỏ trùng (mạng + mã). Máy chủ cũ chỉ trả `tamDung` → một phần tử. */
export function cacTamDung(tq: TongQuanBot | undefined): NonNullable<TongQuanBot["tamDung"]>[] {
  const ds = tq?.tamDungCa?.length ? tq.tamDungCa : tq?.tamDung ? [tq.tamDung] : [];
  const thay = new Set<string>();
  return ds.filter((t) => { const k = `${t.mang}|${t.ma}`; if (thay.has(k)) return false; thay.add(k); return true; });
}
/** Chip “bot đang làm gì” (gopTrangThaiBot): bot đang TẠM DỪNG mà chip vẫn ghi “rảnh” là nói dối → ghi “tạm dừng”. Trạng thái khác (chạy, chờ duyệt, dạy, ngoại tuyến) giữ nguyên. */
export function chipDangLam<T extends { text: string; kind: string }>(what: T, tt: { loai: string }): T & { tamDung: boolean } {
  return what.kind === "idle" && tt.loai === "tam-dung" ? { ...what, text: "tạm dừng", tamDung: true } : { ...what, tamDung: false };
}
/** Nhãn nút đỏ nháy ở thẻ bot: mã captcha / checkpoint / xác minh → "Giải CAPTCHA"; mã khác (can_nguoi: câu hỏi tham gia nhóm, màn hình lạ AI không xử lý được…) → "Cần bạn xử lý". Không tạm dừng → nút thường "Giải CAPTCHA". */
export function nhanNutXuLy(td: { ma: string } | null | undefined): string {
  if (!td) return "Giải CAPTCHA";
  return td.ma === "captcha" || td.ma === "checkpoint" || td.ma === "xac_minh" ? "Giải CAPTCHA" : "Cần bạn xử lý";
}
/** Tình trạng bot bằng chữ: đang chạy / chờ duyệt / tạm dừng / rảnh / ngoại tuyến; `lanCuoi` = trạng thái lần chạy vừa kết thúc (nếu trang đã nghe được). */
export function tinhTrangBot(b: Bot, tq: TongQuanBot | undefined, lanCuoi: string | undefined): { chu: string; loai: LoaiTinhTrang; them?: string[] } {
  if (!b.online) return { chu: b.current ? "Mất liên lạc" : "Ngoại tuyến", loai: "ngoai-tuyen" };
  const tds = cacTamDung(tq);
  if (tds.length) return { chu: chuTamDung(tds[0]!), loai: "tam-dung", ...(tds.length > 1 ? { them: tds.slice(1).map(chuTamDung) } : {}) };
  if (b.current?.status === "paused_otp") return { chu: "Chờ nhập mã OTP", loai: "cho-duyet" };
  if (b.current?.status === "paused_approval" || demChoDuyet(b, tq) > 0) return { chu: "Chờ bạn duyệt", loai: "cho-duyet" };
  if (b.current || tq?.chuoi?.trangThai === "dang_chay") return { chu: "Đang chạy", loai: "chay" };
  if (tq?.chuoi) return { chu: "Đang nghỉ giữa các kịch bản", loai: "nghi" };
  if (b.status?.teaching) return { chu: "Đang dạy", loai: "ranh" };
  if (lanCuoi === "stopped" || lanCuoi === "da_huy") return { chu: "Đã dừng", loai: "da-dung" };
  if (lanCuoi === "done") return { chu: "Vừa chạy xong", loai: "ranh" };
  if (lanCuoi === "failed" || lanCuoi === "halted") return { chu: "Lần chạy cuối bị lỗi", loai: "loi" };
  return { chu: "Rảnh", loai: "ranh" };
}

/** Khoá đặc biệt trong lựa chọn tay: "off" = người dùng bấm "Tắt hết hình" → không tự bật hình nữa tới khi bấm "Bật hình tự động". */
export const KHOA_TAT_TU_BAT = "*";

export interface DauVaoChonO {
  bots: Bot[];
  /** Số liệu tổng quan theo bot — chỉ để SẮP XẾP thứ tự mở (không còn để giới hạn). */
  tq: Map<string, TongQuanBot>;
  /** Lựa chọn tay của người dùng: "on" = luôn xem, "off" = không tự bật lại. */
  tay: Map<string, "on" | "off">;
  /** Ô đang mở hình → lúc bật (số tăng dần). */
  dangXem: Map<string, number>;
  /** Mã tài khoản đang đăng nhập — CHỈ bot của chính mình mới TỰ bật hình (riêng tư: Super thấy bot Boss khác nhưng không tự phát hình máy họ). null = chưa biết → không tự bật. */
  nguoiDung: string | null;
}
/**
 * Các ô nên mở hình: MỌI bot trực tuyến CỦA MÌNH (ownerId === nguoiDung; kể cả bot rảnh), không giới hạn số ô; thứ tự trả về = thứ tự mở (bị tạm dừng → chờ duyệt → đang chạy → rảnh, cùng nhóm theo tên). Người dùng bấm Xem ("on") đứng trước (theo thứ tự đã bật), bot người dùng đã
 * bấm Tắt hình ("off") không tự bật lại; "Tắt hết hình" (khoá "*") tắt tự bật. Bot đang mở hình mà rớt mạng thì GIỮ ô (ô báo ngoại tuyến, hình tự về khi nối lại).
 */
export function chonOXem(d: DauVaoChonO): string[] {
  const theoId = new Map(d.bots.map((b) => [b.id, b]));
  const out: string[] = [];
  const them = (id: string): void => { if (!out.includes(id)) out.push(id); };
  const tayBat = [...d.tay].filter(([id, v]) => v === "on" && theoId.has(id)).map(([id]) => id)
    .sort((a, b) => (d.dangXem.get(a) ?? Number.POSITIVE_INFINITY) - (d.dangXem.get(b) ?? Number.POSITIVE_INFINITY));
  for (const id of tayBat) them(id);
  const tuBat = d.tay.get(KHOA_TAT_TU_BAT) !== "off"; // "Tắt hết hình" đặt khoá này: không tự bật ô nào nữa, chỉ còn ô người dùng bấm Xem
  const hang = (b: Bot): number => THU_TU_NHOM[nhomCuaBot(b, d.tq.get(b.id))];
  for (const b of [...d.bots].sort((x, y) => hang(x) - hang(y) || soSanhTenBot(x.name, y.name))) {
    if (d.tay.get(b.id) === "off") continue;
    if (!b.online) { if (d.dangXem.has(b.id)) them(b.id); continue; } // rớt mạng khi đang mở hình: giữ ô
    if (tuBat && !!d.nguoiDung && b.ownerId === d.nguoiDung) them(b.id); // chỉ bot CỦA MÌNH; bot Boss khác chỉ có hình khi người dùng bấm Xem
  }
  return out;
}

const KHOA_NHO = "boss.xemHinh";
/** Nhớ lựa chọn tay (Xem / Tắt hình) trong phiên trình duyệt (sessionStorage): F5 vẫn còn; kho bị chặn hoặc hỏng → chỉ giữ trong bộ nhớ. */
export class NhoLuaChon {
  private readonly m = new Map<string, "on" | "off">();
  constructor(private readonly kho: Pick<Storage, "getItem" | "setItem" | "removeItem"> | undefined) {
    try {
      const raw = kho?.getItem(KHOA_NHO);
      const o = raw ? (JSON.parse(raw) as unknown) : null;
      if (o && typeof o === "object" && !Array.isArray(o)) for (const [k, v] of Object.entries(o)) if (v === "on" || v === "off") this.m.set(k, v);
    } catch { /* kho bị chặn / dữ liệu hỏng: bắt đầu trống */ }
  }
  private ghi(): void {
    try {
      if (!this.m.size) this.kho?.removeItem(KHOA_NHO);
      else this.kho?.setItem(KHOA_NHO, JSON.stringify(Object.fromEntries(this.m)));
    } catch { /* không lưu được: vẫn còn trong bộ nhớ */ }
  }
  lay(id: string): "on" | "off" | undefined { return this.m.get(id); }
  layTatCa(): Map<string, "on" | "off"> { return new Map(this.m); }
  dat(id: string, v: "on" | "off"): void { this.m.set(id, v); this.ghi(); }
  xoa(id: string): void { this.m.delete(id); this.ghi(); }
  xoaHet(): void { this.m.clear(); this.ghi(); }
}
